import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { CompraService } from '../service/compra.service';
import {
  BaseResourceListComponent, Coluna, Compra, CompraItem, Filtro, FormatoExportacao, FuncaoService, GlobalService, LoginContabil
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

declare var $: any;

@Component({
  selector: 'lib-compra-selecionar-item-dlg',
  templateUrl: './compra-selecionar-item-dlg.component.html'
})
export class CompraSelecionarItemDlgComponent implements OnInit {


  @Input() lista: CompraItem[] = []
  @Output() finalizado: EventEmitter<CompraItem[]> = new EventEmitter();

  /**
   * Declaração de variáveis
   */
  @Input() titulo: string = 'SELECIONAR ITENS DE COMPRA';

  public selAll: boolean = false;
  public filtro: string = '';

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    public funcaoService: FuncaoService,
    public globalService: GlobalService,
    private compraService: CompraService) {
  }

  ngOnInit(): void { }

  public finalizar() {
    this.finalizado.emit(this.listaSel(true));
    $('#dlg_selecionar_item').modal('hide');
  }

  public selecionar(item: CompraItem, sel: boolean) {
    item['selecionado'] = sel;
  }

  public listaSel(sel: boolean): CompraItem[] {
    let lista = this.lista.filter((c) => sel ? c['selecionado'] : !c['selecionado']);
    if (!sel && this.filtro)
      lista = lista.filter((f) => {
        if (f.produto_unidade.produto.nome.toLowerCase().includes(this.filtro.toLowerCase()))
          return true;
        if (f.produto_unidade.unidade.nome.toLowerCase().includes(this.filtro.toLowerCase()))
          return true;
        if (f.produto_unidade.produto.codigo.toLowerCase().includes(this.filtro.toLowerCase()))
          return true;
      });
    return lista;
  }

  public selecionarTodos() { }

  public onClick(filtro: string) {
    this.filtro = filtro;
  }

}
